export const OPERATIONS = {
  LESS: 'less',
  LESS_OR_EQUAL: 'lessOrEqual',
  EQUAL: 'equal',
  GREATER_OR_EQUAL: 'greaterOrEqual',
  GREATER: 'greater'
};

export default OPERATIONS;
